import EditParticipantsContainer from './edit-participants-container';

export default EditParticipantsContainer;
